

interface StatesByCountry {
    [countryCode: string]: { [stateCode: string]: string }
}

export const statesByCountry: StatesByCountry = {
    "US":
    {
        "AK": "Alaska",
        "AL": "Alabama",
        "AR": "Arkansas",
        "AS": "American Samoa",
        "AZ": "Arizona",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DC": "District of Columbia",
        "DE": "Delaware",
        "FL": "Florida",
        "GA": "Georgia",
        "GU": "Guam",
        "HI": "Hawaii",
        "IA": "Iowa",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "MA": "Massachusetts",
        "MD": "Maryland",
        "ME": "Maine",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MO": "Missouri",
        "MP": "Northern Mariana Islands",
        "MS": "Mississippi",
        "MT": "Montana",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "NE": "Nebraska",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NV": "Nevada",
        "NY": "New York",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "PR": "Puerto Rico",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UM": "United States Minor Outlying Islands",
        "UT": "Utah",
        "VA": "Virginia",
        "VI": "Virgin Islands, U.S.",
        "VT": "Vermont",
        "WA": "Washington",
        "WI": "Wisconsin",
        "WV": "West Virginia",
        "WY": "Wyoming"
    }
    ,
    "CA":
    {
        "AB": "Alberta",
        "BC": "British Columbia",
        "MB": "Manitoba",
        "NB": "New Brunswick",
        "NL": "Newfoundland and Labrador",
        "NS": "Nova Scotia",
        "NT": "Northwest Territories",
        "NU": "Nunavut",
        "ON": "Ontario",
        "PE": "Prince Edward Island",
        "QC": "Quebec",
        "SK": "Saskatchewan",
        "YT": "Yukon"
    }
    ,
    "NZ":
    {
        "AU": "Auckland",
        "BP": "Bay of Plenty",
        "CA": "Canterbury",
        "CI": "Chatham Islands Territory",
        "GI": "Gisborne",
        "HB": "Hawke's Bay",
        "MA": "Marlborough",
        "MW": "Manawatu-Wanganui",
        "NE": "Nelson",
        "NO": "Northland",
        "OT": "Otago",
        "SO": "Southland",
        "TS": "Tasman",
        "TK": "Taranaki",
        "WG": "Wellington",
        "WK": "Waikato",
        "WC": "West Coast"
    }
    ,
    "AU":
    {
        "CT": "ACT",
        "NS": "NSW",
        "NT": "NT",
        "QL": "QLD",
        "SA": "SA",
        "TS": "TAS",
        "VI": "VIC",
        "WA": "WA",
    }

}
